import { BlocksIcon, CodeIcon, DiamondPlusIcon, FileCode2Icon, LayersIcon, LayoutGridIcon } from 'lucide-react'
import { Button, ToggleOptionGroup, ToggleOptionGroupItem } from 'twyne-new.ui'

import { StateToolbarButton } from '@/components/builder/utils/State'
import { useBuilderStore } from '@/components/builder/utils/store'
import { DefaultChangeHistory } from '@/components/change-history'
import { useLeftSidebar, useView } from '@/modules/cms/views/post/components/builder/context'

import BuilderConfig from '../../BuilderConfig'

import BreadcrumbsBlocks from './BreadcrumbsBlocks'
import Versions from './Versions'

export default function Toolbar({ history = <ChangeHistory />, versions = <Versions /> }) {
  return <div className='h-12 px-4 grid grid-cols-3 items-center twy-bg-base border-b twy-border-base'>
    <div className='flex h-12 min-w-0 items-center'>
      <BreadcrumbsBlocks />
    </div>
    <div className='flex justify-center'>
      <ViewToggle />
    </div>
    <div className='flex items-center justify-end gap-1'>
      <StateToolbarButton />
      {versions}
      {history}
      <BuilderConfig />
    </div>
  </div>
}

export function PageButton(props) {
  return <SidebarButton name='page' icon={FileCode2Icon} {...props}>Pages</SidebarButton>
}

export function AssetsButton(props) {
  return <SidebarButton name='assets' icon={DiamondPlusIcon} {...props}>Assets</SidebarButton>
}

export function LayersButton(props) {
  return <SidebarButton name='layers' icon={LayersIcon} {...props}>Layers</SidebarButton>
}

export function BlocksButton(props) {
  return <SidebarButton name='blocks' icon={BlocksIcon} {...props}>Blocks</SidebarButton>
}

function SidebarButton({ children, name, icon: Icon, size = 'md' }) {
  const leftSidebar = useLeftSidebar()

  const handleClick = () => {
    leftSidebar.setValue(oldValue => oldValue !== name ? name : undefined)
  }

  const active = leftSidebar.value === name

  return <Button size={size} variant={active ? 'light' : 'ghost'} color={active ? 'accent' : 'neutral'} onClick={handleClick}>
    <Icon size={size === 'sm' ? 14 : 16} />
    {children}
  </Button>
}

function ViewToggle() {
  const { value: view, setValue: setView } = useView()

  return <ToggleOptionGroup type='single' size='md' value={view} onValueChange={value => value && setView(value)}>
    <ToggleOptionGroupItem value='builder' className='flex items-center gap-2'>
      <LayoutGridIcon size={16} />
      Builder
    </ToggleOptionGroupItem>
    <ToggleOptionGroupItem value='code' className='flex items-center gap-2'>
      <CodeIcon size={16} />
      Code
    </ToggleOptionGroupItem>
  </ToggleOptionGroup>
}

function ChangeHistory() {
  const { postBuilder, loading } = useBuilderStore()
  return <DefaultChangeHistory entityName="cms_post_builders" entityCollection={postBuilder} loading={loading} />
}
